import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-login-modal',
  template: `
    <div class="modal-body">
      <app-login-component [isModal]="isModal" [redirectTo]="redirectTo"></app-login-component>
    </div>
  `
})
export class LoginModalComponent {
  @Input() isModal: boolean;
  @Input() redirectTo: string;
  constructor(public activeModal: NgbActiveModal) {}
}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/login-modal.component.ts